// utils/getApiUrl.ts
export const getApiUrl = () => {
  const origin = window.location.origin
  if (origin === 'https://app.goparco.com')
    return 'https://1p9cjflrkb.execute-api.us-east-2.amazonaws.com'
  if (origin === 'https://beta.goparco.com')
    return 'https://cxvd9h4swb.execute-api.us-east-2.amazonaws.com'
  if (origin === 'https://dev.goparco.com')
    return 'https://ilam8kqjcd.execute-api.us-east-2.amazonaws.com'
  if (origin === 'http://localhost:3000') return process.env.REACT_APP_API_URL
  return 'https://ilam8kqjcd.execute-api.us-east-2.amazonaws.com'
}
